import { render, staticRenderFns } from "./SuccessSubmitForm9.vue?vue&type=template&id=60bddbe1&scoped=true"
import script from "./SuccessSubmitForm9.vue?vue&type=script&lang=ts"
export * from "./SuccessSubmitForm9.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bddbe1",
  null
  
)

export default component.exports